export default class PageCover {
  constructor(item, lang) {
    this._setId(item);
    this._setDescription(item, lang);
    this._setImage(item);
    this._setTitle(item.aboutType, lang);
    this._setTypeId(item.aboutType);
  }

  /**
   * set id
   * @param {id} param0
   */
  _setId({ id }) {
    this.id = id;
  }

  /**
   * set description
   * @param {page-cover} item
   * @param {language} lang
   */
  _setDescription(item, lang) {
    let key = "description_" + lang;
    this.description = item[key];
  }

  /**
   * set image
   * @param {photoUrl} param0
   */
  _setImage({ photoUrl }) {
    this.image = photoUrl;
  }

  /**
   * set title
   * @param {about-type} item
   * @param {language} lang
   */
  _setTitle(item, lang) {
    let key = "name_" + lang;
    this.title = item[key];
  }

  /**
   * set type id
   * @param {id} param0
   */
  _setTypeId({ id }) {
    this.typeId = id;
  }
}
